function hexToRgb (hex: string) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
  return result ? [
    parseInt(result[1], 16),
    parseInt(result[2], 16),
    parseInt(result[3], 16)
  ] : []
}

export function toRgb (color: string) {
  if (color.startsWith('var')) return [color]
  if (color.startsWith('rgb')) {
    return color
      .replace(/[a-z()]/gi, '')
      .split(/[\s,]+/)
      .slice(0, 3)
  }
  return hexToRgb(color)
}

export function softColor (color: string, percent: number = 10) {
  const alpha = percent / 100
  const rgb = hexToRgb(color)
  if (!rgb) return color
  return '#' + rgb.map((n) => {
    return Math.min(Math.floor(n * alpha + 255 * (1 - alpha)), 255)
      .toString(16)
      .padStart(2, '0')
  }).join('')
}

export function darkenColor (color: string, percent: number = 10) {
  const alpha = percent / 100
  let [R, G, B] = hexToRgb(color)
  R = Math.max(Math.floor(R * alpha), 0)
  G = Math.max(Math.floor(G * alpha), 0)
  B = Math.max(Math.floor(B * alpha), 0)
  return (
    '#' +
    R.toString(16).padStart(2, '0') +
    G.toString(16).padStart(2, '0') +
    B.toString(16).padStart(2, '0')
  )
}

export function cssUtility (name: string, value: string) {
  value = value || `var(--topbar-${name})`
  const textValue = value.startsWith('var') ? `rgba(${value}, var(--topbar-text-opacity, 1))` : value
  const bgValue = value.startsWith('var') ? `rgba(${value}, var(--topbar-bg-opacity, 1))` : value
  const borderValue = value.startsWith('var') ? `rgba(${value}, var(--topbar-border-opacity, 1))` : value
  return `
.text-${name} {
  color: ${textValue} !important;
}
.bg-${name} {
  background-color: ${bgValue} !important;
}
.border-${name} {
  border-color: ${borderValue} !important;
}
`
}